import React from 'react'
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import useAuth from '../../../features/hooks/useAuth'
import { useGetAssetsFinalQuery } from '../../../features/addassets/addassetfinalApiSlice';
import { useGetUsersQuery } from '../../../features/users/usersApiSlice';
import BarChart from './Charts/UserDashCharts/BarChart';
import moment from 'moment';


const Container = styled.div``
const Wrapper = styled.div``

const UserDashboard = () => {
  // logged in user info
  const { id, email, designation, designationSuffix, numSuffix, office, roles } = useAuth()
  let user_current_office = (useSelector((state) => state.office.off))
  let user_current_role_array = roles[user_current_office]

  //Single user call
  const { getSingleuser } = useGetUsersQuery('userslist', {
    selectFromResult: ({ data }) => ({
      getSingleuser: data?.entities
    }),
  })

  //get single assets
  const { getSingleasset } = useGetAssetsFinalQuery('allassetlist', {
    selectFromResult: ({ data }) => ({
      getSingleasset: data?.entities
    }),
  })

  //call single user data of the user logged in
  let singleUser_data = getSingleuser && getSingleuser[id]
  let officeAssetswithUser = singleUser_data?.assets[user_current_office]
  let assetsArray = getSingleasset && officeAssetswithUser?.map(elm => { return getSingleasset && getSingleasset[elm] })
  let data = assetsArray?.map(elm => { return { name: elm.name, oem_tag: elm.oem_tag, issueDate: elm.last_trans_date, expDate: elm.warrantyexp_date } })

  return (
    <Container>
      <Wrapper>
        <BarChart Data={data} />
      </Wrapper>
    </Container>
  )
}

export default UserDashboard